import React from "react";

export default function SvgWishes(props) {
  const { color, svg } = props;

  return (
    <div style={{ position: "relative" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        style={{ position: "absolute", top: 0, left: 0, marginTop: -21 }}
      >
        <path fill={color} fill-opacity=".3" d={svg}></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        style={{ position: "absolute", top: 0, left: 0, marginTop: -14 }}
      >
        <path fill={color} fill-opacity=".5" d={svg}></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        style={{ position: "absolute", top: 0, left: 0, marginTop: -7 }}
      >
        <path fill={color} fill-opacity=".7" d={svg}></path>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        style={{ position: "absolute", top: 0, left: 0 }}
      >
        <path fill={color} fill-opacity="1" d={svg}></path>
      </svg>
    </div>
  );
}
